import { LIST_VMKEYLIST } from '../actions'


export function vmKeylist(state = [], action) {
  switch (action.type) {
    case LIST_VMKEYLIST:
      var vmKeylist = action.payload.data.map(item => ({value:item.id, label:item.serialNumber}))
      return vmKeylist;
    default:
      return state
  }
}